<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px">
      {{ startDate }}ss
      <template v-slot:activator="{ on }">
        <v-btn @click="exportExcel" v-on="on" height="40px" color="primary" class="light--text text-capitalize btn_fnt"> <v-icon small class="me-2">fa-file-export</v-icon>Export</v-btn>
      </template>

      <div v-show="false">
        <v-data-table id="exportAgeWiseCustomerList" hide-default-footer :items-per-page="-1" :headers="headers" :items="customerList" class="mt-6 elevation-1">
          <template v-slot:[`item.customerId`]="{ item }">
            {{ padLeft(item.customerId, 4) }}
          </template>
          <template v-slot:[`item.name`]="{ item }">
            {{ item.user.firstnameEn[0].toUpperCase() + item.user.firstnameEn.substring(1) }}
            <!-- <div class="mx-1" /> -->
            {{ item.user.lastnameEn[0].toUpperCase() + item.user.lastnameEn.substring(1) }}
            <!-- </v-row> -->
          </template>
          <template v-slot:[`item.tag`]="{ item }">
            <span v-for="tag in item.tags" :key="tag._id"> {{ tag.name }}<br /> </span>
          </template>

          <template v-slot:[`item.area`]="{ item }">
            {{ defaultArea(item.addressDetails) }}
          </template>

          <template v-slot:[`item.block`]="{ item }">
            {{ defaultBlock(item.addressDetails) }}
          </template>

          <template v-slot:[`item.building`]="{ item }">
            {{ defaultBuilding(item.addressDetails) }}
          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ createdDate(item.createdAt) }}
          </template>
        </v-data-table>
      </div>
    </v-dialog>
    <v-snackbar v-show="false" v-model="snackbar" timeout="3000" right top :color="snackbarColor">{{ text }}</v-snackbar>
  </div>
</template>
<script>
import { requiredValidator } from "../../../core/methods/validations";
import { DATE_FORMAT, Utils } from "../../../utils/utils";
import moment from "moment";
export default {
  props: {
    headers: {
      type: Array,
    },
    ageFrom: {
      type: Number,
    },
    ageTo: {
      type: Number,
    },
    areas: Array,
    blocks: Array,
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      snackbar: false,
      text: "",
      snackbarColor: "",
      valid: true,
      dialog: false,
      btnloading: false,
      show_alert: false,
      error: null,
      requiredValidator,
      menuStartDate: false,
      menuEndDate: false,
      customerList: [],
      // startDateAllowedDates:''
    };
  },
  methods: {
    selectStartDate() {
      this.menuStartDate = false;
      if (!this.endDate || moment(this.endDate).diff(this.startDate, "month") != 0) {
        this.endDate = moment(this.startDate)
          .add(1, "month")
          .format("YYYY-MM-DD");
      }
    },
    selectEndDate() {
      this.menuEndDate = false;
      if (!this.startDate || moment(this.startDate).diff(this.endDate, "month") != 0) {
        this.startDate = moment(this.endDate)
          .subtract(1, "month")
          .format("YYYY-MM-DD");
      }
    },
    setAreaAndBlock() {
      this.customerList.forEach(element => {
        if (element.addressDetails) {
          element.addressDetails.forEach(address => {
            if (address.area) {
              let area = this.areas.find(x => x._id == address.area._id);
              address.area = area;
            }
            if (address.block) {
              let block = this.blocks.find(x => x._id == address.block._id);
              address.block = block;
            }
          });
        }
      });
    },
    customersList() {
      let variables = {
        input: {
          limit: 0,
          skip: 0,
          sortDesc: false,
          sortBy: "",
        },
        filter: {
          ageFrom: this.ageFrom,
          ageTo: this.ageTo,
          fromDate: this.startDate,
          toDate: this.endDate,
        },
      };
      this.$apollo
        .query({
          query: require("@/customer/api/customerAgeWiseReport.graphql"),
          variables,
        })
        .then(async data => {
          console.log(data);
          if (data.data) {
            this.customerList = await data.data.customerAgeWiseReport.customers;
            console.log(this.customerList);
            if (this.customerList.length) {
              this.setAreaAndBlock();
              setTimeout(() => {
                Utils.htmlToExcel("exportAgeWiseCustomerList", "AgeWiseReport", false);
              }, 100);
              this.dialog = false;
            } else {
              this.snackbarColor = "red";
              this.text = "No Data is available on selected dates";
              this.snackbar = true;
            }
            this.btnloading = false;
            return true;
          }
          this.snackbarColor = "red";
          this.text = "some error";
          this.snackbar = true;
          return false;
        });
    },
    close() {
      this.error = null;
      this.dialog = false;
      this.$refs.form.reset();
    },
    padLeft(number, length) {
      var stringValue = "" + number;
      while (stringValue.length < length) {
        stringValue = "0" + stringValue;
      }
      return stringValue;
    },
    async exportExcel() {
      this.btnloading = true;
      await this.customersList();
    },
    defaultArea(addresses) {
      if (addresses.length > 0) {
        let defaultAddress = addresses.find(x => x.is_default == true);
        if (defaultAddress) {
          return defaultAddress.area.nameEn;
        } else {
          return addresses[0].area.nameEn;
        }
      }
    },
    defaultBuilding(addresses) {
      let address = "";
      if (addresses.length > 0) {
        let defaultAddress = addresses.find(x => x.is_default == true);
        if (defaultAddress) {
          address = `${defaultAddress.house_number}, ${defaultAddress.building_number}, ${defaultAddress.apartment_number}`;
          return address;
        } else {
          address = `${addresses[0].house_number}, ${addresses[0].building_number}, ${addresses[0].apartment_number}`;
          return address;
        }
      }
    },
    defaultBlock(addresses) {
      let address = "";
      if (addresses.length > 0) {
        let defaultAddress = addresses.find(x => x.is_default == true);
        if (defaultAddress) {
          address = `${defaultAddress.block.block}, ${defaultAddress.street}, ${defaultAddress.jedha}`;
          return address;
        } else {
          address = `${addresses[0].block.block}, ${addresses[0].street}, ${addresses[0].jedha}`;
          return address;
        }
      }
    },
    createdDate(date) {
      return date ? moment(parseInt(date)).format(DATE_FORMAT) : "";
    },
  },
  computed: {
    formatStartDate() {
      return this.startDate ? moment(this.startDate).format(DATE_FORMAT) : "";
    },
    formatEndDate() {
      return this.endDate ? moment(this.endDate).format(DATE_FORMAT) : "";
    },
    startDateMinDates() {
      return this.endDate
        ? moment(this.endDate)
            .subtract(1, "month")
            .format("YYYY-MM-DD")
        : "";
    },
    startDateMaxDates() {
      let today = moment().format("YYYY-MM-DD");
      return this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : today;
    },
    endDateMaxDates() {
      let today = moment();
      if (this.startDate) {
        let day = moment(this.startDate).add(1, "month");
        if (day > today) {
          return today.format("YYYY-MM-DD");
        } else {
          return day.format("YYYY-MM-DD");
        }
      } else {
        return today.format("YYYY-MM-DD");
      }
    },
    endDateMinDates() {
      return this.startDate ? moment(this.startDate).format("YYYY-MM-DD") : "";
    },
  },
};
</script>
